import { ApiClient, GetResponseType } from '@make-software/tg-mini-app-ui';

import { WITH_AUTH } from '@/shared';
import { GetMakePrimaryResponseType, GetGiveawayDataResponseType } from '@/entities';

export const searchCSPRSubname = async (
  subname: string,
): Promise<GetResponseType<{ available: boolean }>> => {
  return await ApiClient.get<{ available: boolean }>(
    `${window.config.api_endpoint}/subname-giveaway/availability?label=${subname}`,
    WITH_AUTH
  );
};

export const getGiveawayData = async () => {
  const { data, error, loading, httpCode } = await ApiClient.get<GetGiveawayDataResponseType>(
    `${window.config.api_endpoint}/subname-giveaway`,
    WITH_AUTH
  );

  return {
    data,
    httpCode,
    error,
    loading
  };
};

export const claimSubname = async (
  subname: string,
): Promise<GetResponseType<{ tx_hash: string }>> => {
  return await ApiClient.post<{ tx_hash: string }>(
    `${window.config.api_endpoint}/subname-giveaway/mint?label=${subname}`,
    {},
    WITH_AUTH
  );
};

export const makeSubnamePrimary = async (
  subname: string,
) => {
  const { data, error, loading, httpCode } =  await ApiClient.get<GetMakePrimaryResponseType>(
    `${window.config.api_endpoint}/subname-giveaway/make-primary?label=${subname}`,
    WITH_AUTH
  );

  return {
    data,
    httpCode,
    error,
    loading
  };
};
